import { fundersSelect } from '@/components/molecules/funders-select/index';
import { locationSelect } from '@/components/molecules/location-select/index';
import { monthYearField } from '@/components/molecules/month-year-field/index';
import { slideshow } from '@/components/molecules/slideshow/index';
import { videoPlaceholder } from '@/components/molecules/video-placeholder/index';

// Dynamically imported so the Google Maps SDK and clustering code are only
// ever fetched on pages that actually add a 'map' module, not bundled globally.
const map = (configs) => import('@/components/molecules/map/index').then(({ map: initMap }) => initMap(configs));

export default {
  fundersSelect,
  locationSelect,
  monthYearField,
  slideshow,
  videoPlaceholder,
  map,
};
